module.exports = __webpack_public_path__ + "img/pdf-icon.cefb56c5.png";